<div class="bmc-user-jobs-wrapper">
    <user-jobs-list [userJobs]="userJobs" [currentUserJob]="currentUserJob"  class="bmc-user-jobs-wrapper__left" (onSetUserJob)="setCurrentJob($event)" [filterExecutionStatus]="filterExecutionStatus"></user-jobs-list>
    <user-jobs-description 
      *ngIf="userJobs.length" 
      class="bmc-user-jobs-wrapper__right" 
      [userJobs]="userJobs"
      [currentUserJob]="currentUserJob" 
      (cancel)="currentUserJob = null" 
      (resetEmit)="reset()" 
      (userJobUpdate)="setUserJob($event)">
    </user-jobs-description>
    <div class="bmc-user-jobs-wrapper__no-items" *ngIf="!userJobs.length">
        <h3>{{'WAITS.NO_WAITS_TITLE' | translate}}</h3>
        <h4>{{'WAITS.NO_WAITS_SUBTITLE' | translate}}</h4>
      </div>
</div>
